// extracted by extract-css-chunks-webpack-plugin
module.exports = {"seller-directory":"seller-directory___IciuT","global-regions":"global-regions___15bPz"};